const ButtonNavigationRight = ({ size = 24, fill = null, disabled = false }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill={disabled ? '#BDBCBC' : '#CE181E'} />
      <g clip-path="url(#clip0_11321_78073)">
        <path
          d="M11.4014 8.62383L11.7978 8.22744C11.9656 8.0596 12.237 8.0596 12.4031 8.22744L15.8741 11.6967C16.042 11.8645 16.042 12.1359 15.8741 12.302L12.4031 15.773C12.2352 15.9409 11.9638 15.9409 11.7978 15.773L11.4014 15.3766C11.2318 15.207 11.2354 14.9303 11.4085 14.7642L13.5601 12.7144H8.42852C8.19105 12.7144 8 12.5234 8 12.2859V11.7146C8 11.4771 8.19105 11.286 8.42852 11.286H13.5601L11.4085 9.23626C11.2336 9.0702 11.23 8.79345 11.4014 8.62383Z"
          fill="#FFFEFE"
        />
      </g>
      <defs>
        <clipPath id="clip0_11321_78073">
          <rect width="8" height="8" fill="white" transform="translate(8 8)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ButtonNavigationRight;
